import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import {
  Card, CardBody, CardHeader, Table,
} from 'reactstrap';

function SaleInvoices(props) {
  const { t, sale } = props;
  const invoices = sale?.invoices || [];

  if (invoices.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader className="bg-transparent border-bottom">
        {t('Invoices')}
      </CardHeader>
      <CardBody>
        <Table responsive size="sm" bordered striped className="mb-0">
          <thead>
            <tr>
              <th>{t('ID')}</th>
              <th>{t('Exported')}</th>
              <th>{t('At')}</th>
              <th>{t('Items')}</th>
              <th>{t('Total')}</th>
              <th>{t('QuickBooks Error')}</th>
            </tr>
          </thead>
          <tbody>
            {invoices.map((invoice) => (
              <tr key={invoice.id}>
                <td className="align-middle">{invoice.id}</td>
                <td className="align-middle">
                  {invoice.exported_at !== null && (
                    <span className="mdi mdi-checkbox-marked-outline text-success fs-3" />
                  )}
                  {invoice.exported_at === null && (
                    <span className="mdi mdi-checkbox-blank-outline text-default fs-3" />
                  )}
                </td>
                <td className="align-middle">{invoice.created_at ? moment(invoice.created_at).format('M/D/YYYY h:mma') : '-'}</td>
                <td className="align-middle">
                  {(invoice.items || []).map((item) => (
                    <div key={item.id}>
                      {item?.sale_item?.listing?.sku || item?.description || t('Unknown SKU')}
                      {' '}
                      (
                      {item.qty}
                      )
                    </div>
                  ))}
                </td>
                <td className="align-middle">{invoice.total ?? '-'}</td>
                <td className="align-middle text-danger">{invoice.quickbooks_last_error || '-'}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  );
}

SaleInvoices.propTypes = {
  t: PropTypes.func.isRequired,
  sale: PropTypes.shape({
    invoices: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      created_at: PropTypes.string,
      exported_at: PropTypes.string,
      quickbooks_last_error: PropTypes.string,
      total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      items: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        qty: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        sale_item: PropTypes.shape({
          listing: PropTypes.shape({
            sku: PropTypes.string,
          }),
        }),
      })),
    })),
  }).isRequired,
};

export default withTranslation()(SaleInvoices);
